// Only a non-sensitive preference is stored here. Authentication stays in HttpOnly cookies.
export const CONSENT_KEY = "ega-cookie-consent";
export const CONSENT_TTL = 180 * 24 * 60 * 60 * 1000;
const CHOICES = new Set(["all", "essential"]);

const validRecord = (record, now) => record?.version === 1
  && CHOICES.has(record.choice)
  && Number.isFinite(record.acceptedAt) && record.acceptedAt <= now
  && Number.isFinite(record.expiresAt) && record.expiresAt > now
  && record.expiresAt - record.acceptedAt === CONSENT_TTL;

export const readConsent = (now = Date.now()) => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    const record = JSON.parse(stored);
    if (validRecord(record, now)) return record;
    localStorage.removeItem(CONSENT_KEY);
  } catch {
    // Legacy strings, corrupt data and denied storage must never break rendering.
  }
  return null;
};

export const saveConsent = (choice, now = Date.now()) => {
  if (!CHOICES.has(choice)) return false;
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      version: 1, choice, acceptedAt: now, expiresAt: now + CONSENT_TTL,
    }));
    return true;
  } catch {
    // The banner can still dismiss for this visit if browser storage is unavailable.
    return false;
  }
};